import FrequenciesAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequencies/frequencies.entity';
import { CommonModule } from '@angular/common';
import { Component, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SubRouteFrequenciesService } from '../../sub-routes-frequency/sub-route-frequency.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import SubRouteBusinessPartnersAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequency-bp/sub-route-frequency-bp.entity';
import { SubRouteFrequenciesBPService } from '../../sub-routes-frequency/sub-route-frequencies-bp.service';
import { CdkDragDrop, CdkDropList, DragDropModule, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { AppointmentAttributes } from '@albatrosdeveloper/ave-models-package';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-modal-appointment',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    DragDropModule,
    MatTableModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatButtonModule
  ],
  templateUrl: './modal-appointment.component.html',
  styleUrl: './modal-appointment.component.scss'
})
export class ModalAppointmentComponent {
  @Input('data') data

  listAppointment: AppointmentAttributes[]= []
  daysList: { code: number; day: string, name: string }[] = [
    {code: 1, day: "LU", name: "Lunes"},
    {code: 2, day: "MA", name: "Martes"},
    {code: 3, day: "MI", name: "Miércoles"},
    {code: 4, day: "JU", name: "Jueves"},
    {code: 5, day: "VI", name: "Viernes"},
    {code: 6, day: "SA", name: "Sábado"},
    {code: 7, day: "DO", name: "Domingo"}
  ];

  expandedElement: FrequenciesAttributes | null;
  tables: { id: string; table: MatTable<any> }[] = [];

  @ViewChildren(CdkDropList) cdkDropLists!: QueryList<CdkDropList>;
  @ViewChildren(MatTable) mainTables!: QueryList<MatTable<any>>;
  @ViewChild("table", { static: false }) table: MatTable<any>;

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(null),
  });

  constructor(
    private readonly frequencyService: SubRouteFrequenciesService,
    private readonly frequencybpService: SubRouteFrequenciesBPService,
    private snackBar: MatSnackBar,
  ){
  }

  ngAfterViewInit(): void {
    let oneMonthLater = new Date();
    oneMonthLater.setMonth(new Date().getMonth() + 1);

    this.range = new FormGroup({
      start: new FormControl<Date | null>(new Date()),
      end: new FormControl<Date | null>(oneMonthLater),
    });
    this.onSearch()
  }

  onSearch(){
    if(this.range.value.start == null || this.range.value.end == null){
      return;
    }
    this.getAppointment()
  }

  getAppointment(){
    const adjustedStart = new Date(this.range.value.start);
    adjustedStart.setHours(0, 0, 0, 0); // 00:00:00.000

    const adjustedEnd = new Date(this.range.value.end);
    adjustedEnd.setHours(23, 59, 59, 999); // 23:59:59.999

    let date = {
      start: adjustedStart.toISOString(), // Convertir a UTC
      end: adjustedEnd.toISOString(),     // Convertir a UTC
    };

    this.frequencyService.findAppointmentWithCount(this.data, date).subscribe({
      next: (res) => {
        if(res.status == 'success' && res.data.length > 0){
            if(res.data[0].data.length > 0){
                this.listAppointment = res.data[0].data.map((appointment: any) => ({
                    ...appointment,
                    businessPartenerAppointmentList: [] as SubRouteBusinessPartnersAttributes[],
                }));
            }
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener las frecuencias","Cerrar",{ duration: 5000});
      },
    });
  }

  getAppointmentDate(date: string | Date) {
    if(date){
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    }
    return '-'
  }

  toggleExpand(element: any) {
    element.expanded = !element.expanded;

    if (this.expandedElement === element) {
      this.expandedElement = null;
      element.businessPartenerAppointmentList = [];
    } else {
      this.expandedElement = element;
      this.fetchBusinessbyFrequency(element);
      const mainTable = this.mainTables.toArray().find((table) => {
        const tableId = table["_elementRef"].nativeElement.getAttribute("id");
        return tableId === `table-${element._id}`;
      });
      this.registerTable(element._id, mainTable);
    }
  }

  closeExpand(element: any){
    element.expanded = !element.expanded
    this.expandedElement = null;
  }

  fetchBusinessbyFrequency(expanded: any): void {
    this.frequencyService.findAppointmentById(expanded._id.toString()).subscribe({
      next: (res) => {
        expanded.businessPartenerAppointmentList = res?.data?.businessPartners;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener frecuencias.","Cerrar",{ duration: 5000});
      },
    });
  }

  registerTable(elementId: string, table: MatTable<any>) {
    this.tables[elementId] = { id: elementId, table: table };
  }

  drop(event: CdkDragDrop<any[]>, elementId: string) {
    let transferredElement;
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data,event.previousIndex,event.currentIndex);
      if (event.container.id.split("-")[1]) {
        this.updateFrequencyPosition(event);
      }
    } else {
      let frequencyId = event.container.id.split("-")[1];
      transferredElement = event.previousContainer.data[event.previousIndex];
      const alreadyExists = event.container.data.some(
        (item) => item._id === transferredElement._id
      );

      if (!frequencyId) {
        let frequencyId = event.previousContainer.id.split("-")[1];
        this.deleteFrequencyBusinessPartner(transferredElement, frequencyId);
      } else {
        this.updateFrequencyBusinessPartner(transferredElement, frequencyId);
      }
      
      if (!alreadyExists) {
        transferArrayItem(event.previousContainer.data,event.container.data,event.previousIndex,event.currentIndex);
      }
    }

    const mainTable = this.mainTables.toArray().find((table) => {
      const tableId = table["_elementRef"].nativeElement.getAttribute('id');
      return tableId === `table-${elementId}`;
    });


    if (mainTable) {
      mainTable.renderRows();
    } else {
      const elementId = event.previousContainer.id.split("-")[1]
      this.tables[elementId].table.renderRows();
      this.table.renderRows();
    }
  }

  updateFrequencyPosition(result): void {
    let businessPartnerPosition: any = {
      businessPartnerId: result.container.data[result.currentIndex]._id.toString(),
      position: result.currentIndex,
    };
    return;
    this.frequencyService.updatePosition(this.data._id,result.container.id.split("-")[1],businessPartnerPosition)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",});
          this.getAppointment()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
        },
      });
  }

  deleteFrequencyBusinessPartner(result, frequencyId: string): void {
    let bpIds = [result._id.toString()]
    this.frequencyService.deleteBusinessPartnerAppointment(frequencyId, bpIds)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro eliminado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",});
          this.getAppointment()
          //this.fetchallBusinessPartner();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al eliminar el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
        },
      });
  }


  updateFrequencyBusinessPartner(result, frequencyId: string): void {
    let bpIds = [result._id.toString()]
    this.frequencyService.createBusinessPartnerAppointment(frequencyId,bpIds)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",panelClass: "snack-bar-success",});
          this.getAppointment()
          //this.fetchallBusinessPartner();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
        },
      });
  }
}
